<template>
  <v-container fill-height fluid class="mb-10">
    <v-row justify="center" align="center">
      <v-col cols="12">
        <v-card flat outlined>
          <v-tabs
            v-model="tab"
            background-color="primary accent-1"
            dark
            centered
            dense
          >
            <v-tabs-slider color="white"></v-tabs-slider>

            <v-tab href="#tab-1">
              <b>Installation key </b>
            </v-tab>
            <v-tab href="#tab-2" :disabled="shopify.accessToken ? false : true">
              <b>Products</b>
            </v-tab>
            <v-tab
              href="#tab-3"
              :disabled="shopify.shopInfos === '{}' ? true : false"
            >
              <b>Shop infos</b>
            </v-tab>
          </v-tabs>
          <v-card-text>
            <v-tabs-items v-model="tab">
              <v-tab-item value="tab-1">
                <Installation />
              </v-tab-item>
              <v-tab-item value="tab-2">
                <Products />
              </v-tab-item>
              <v-tab-item value="tab-3">
                <Shop />
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Installation from "../components/shopify/Installation.vue";
import Products from "../components/shopify/Products.vue";
import Shop from "../components/shopify/Shop.vue";

export default {
  name: "shopify",
  data: () => ({
    tab: null,
  }),
  components: {
    Installation,
    Products,
    Shop,
  },
  computed: {
    shopify() {
      const data = this.$store.state.shopify;
      return data;
    },
  },
  methods: {},
};
</script>
